import { IPayload } from '../../models/Global'
import {
  IUpshifterExperience,
  IGetUpshifterExperienceParams,
  IUpshifterExperienceEnums,
  IUpshifterExpereincePosition,
  IGetUpshifterExperiencePositionsParams,
  IPostUpshifterExperienceParams,
  IPutUpshifterExperienceParams,
} from '../../models/UpshifterExperience'
import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'

export class UpshifterExperiencesApi {
  constructor(private axios: AxiosService) {}

  getUpshifterExperiences = async (params?: IGetUpshifterExperienceParams) => {
    const response = await this.axios.get<IPayload<IUpshifterExperience[]>>(
      Endpoints.getUpshifterExperiences,
      params,
    )
    return response
  }

  getUpshifterExperiencesEnums = async () => {
    const response = await this.axios.get<IPayload<IUpshifterExperienceEnums>>(
      Endpoints.getUpshifterExperiencesEnums,
    )
    return response
  }

  getUpshifterExperiencePositions = async (
    params?: IGetUpshifterExperiencePositionsParams,
  ) => {
    const response = await this.axios.get<
      IPayload<IUpshifterExpereincePosition[]>
    >(Endpoints.getUpshifterExperiencePositions, params)
    return response
  }

  postUpshifterExperience = async (params?: IPostUpshifterExperienceParams) => {
    const response = await this.axios.post<IPayload<IUpshifterExperience>>(
      Endpoints.postUpshifterExpereince,
      params,
    )
    return response
  }
  putUpshifterExperience = async (
    id: number,
    params?: IPutUpshifterExperienceParams,
  ) => {
    const response = await this.axios.put<IPayload<IUpshifterExperience>>(
      Endpoints.putUpshifterExperience(id),
      params,
    )
    return response
  }

  deleteUpshifterExperience = async (id: number) => {
    const response = await this.axios.delete<{}>(
      Endpoints.deleteUpshifterExperience(id),
    )
    return response
  }
}
